import { Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
   selector: 'app-auth-response',
   template: `
       <div class="d-flex flex-column justify-content-center align-items-center mt-5 gap-4">
         <div class="text-center fs-4">Processing ... one moment</div>
         <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
         </div>
      </div>`,
   standalone: true
})

export class AuthResponseComponent {
   /*
      This components sole purpose is for Msal authentication responses,
      where authentication responses can be received by your application.
      It must exactly match one of the redirect URIs registered in the Azure portal.
      They pass info to set cookies and redirect where requested
   */
   constructor(
      _activatedRoute: ActivatedRoute,
      _router: Router
   ) {
      const fragment = _activatedRoute.snapshot.fragment

      if (fragment?.startsWith('token=')) {
         const token = fragment.replace('token=', '')
         const registrationUri = `/${SITE_DIRECTORY_ROUTES.registration.uri}?token=${token}`
         _router.navigateByUrl(registrationUri)
      }
   }
}
